import config from '../globals/config'
export const eventPath = (event_id: string, ...others: any) => {
    let path = `/ContainerApp/v1_0/events/${event_id}`;

    for (let val of others) {
        path += `/${val}`;
    }
    return path;
};

export const moduleConfig = function(event_id: string, ...others: any) {
    let path = `${eventPath(event_id)}/moduleConfiguration`;
    for (let val of others) {
        path += `/${val}`;
    }
    return path;
};

export const moduleData = function(event_id: string, ...others: any) {
    let path = `${eventPath(event_id)}/data`;
    for (let val of others) {
        path += `/${val}`;
    }
    return path;
};

export const user_from_top = (user_id: string) => {
    return `/ContainerApp/v1_0/users/${user_id}`;
};

export const event_config_fb = (event_id: string) => {
    return `/ContainerApp/v1_0/${config.REACT_APP_ACTIVE_MASTER_EVENTS_NODE_FIREBASE}/${event_id}`;
};

export const event_app_config_fb = (event_id: string) => {
    return `/ContainerApp/v1_0/events/${event_id}/appConfiguration`;
};

export const storage_event_image = (active_event: string, filename: string) => {
    return `/ContainerApp/${active_event}/${filename}`;
};

export const storage_alert_user = (active_event: string) => {
    return `/ContainerApp/${active_event}/Inbox/AlertUser/`;
};

export const storage_channel = (active_event: string, channel_id: string) => {
    return `/ContainerApp/${active_event}/Inbox/Chat/Channels/${channel_id}/`;
};

export const storage_moments = (active_event: string, moment_id: string) => {
    return `/ContainerApp/${active_event}/Feed/Moments/Posts/${moment_id}/`;
};
export const storage_moment_filters = (active_event: string, filter_id: string) => {
    return `/ContainerApp/${active_event}/Feed/Moments/Filters/${filter_id}/`;
};
export const storage_schedule = (active_event: string) => {
    return `/ContainerApp/${active_event}/Schedule/`;
};

export const storageDiscover = (active_event: string, discover_id: string) => {
    return `/ContainerApp/${active_event}/Discover/${discover_id}/`;
};

export const storage_discover_global_background = (active_event: string) => {
    return `/ContainerApp/${active_event}/Discover/global-background.jpg`;
};
